import React from "react";
import * as W from "@/lib/waktu";
import { asalRework } from "@/lib/laporMasalah";
import { namaPos } from "@/lib/posNama";
import usePetaPos from "@/lib/usePetaPos";

const waktu = (iso) => {
  if (!iso) return "";
  try { return W.waktu(iso); } catch { return iso; }
};

// Owner 2026-10-08: the QC reject note at every station a rework passes
// (reason, how many pcs, which pcs/players, who rejected and when).
// v2.17: also a station's report ("Lapor masalah dari Press"): the item and its unit.
// `posCode`: the station showing the note; only the station QC named as the cause carries the reject
export default function ReworkNote({ rw, compact = false, testid, posCode }) {
  const peta = usePetaPos();  // v2.17.2: station names, not codes
  if (!rw) return null;
  const bukanPenyebab = posCode && rw.pos_penyebab && rw.pos_penyebab !== posCode && posCode !== "QC";
  const judul = `REWORK${rw.rework_ke ? ` ke-${rw.rework_ke}` : ""}${rw.pos_rework ? ` · mulai ${namaPos(rw.pos_rework, peta, rw.pos_rework_nama)}` : ""}${rw.sumber === "POS" ? ` · ${asalRework(rw)}` : ""}`;
  const satuan = (rw.satuan || "pcs").toLowerCase();
  if (compact) {
    return (
      <span data-testid={testid} className="mt-1 block rounded border border-red-500/40 bg-red-500/10 px-1.5 py-0.5 text-[11px] font-sans text-red-200">
        <b>{judul}</b>: {rw.alasan}{rw.pcs_bermasalah ? ` · ${rw.pcs_bermasalah}` : ""}{rw.qty_reject ? ` (${rw.item && rw.sumber === "POS" ? `${rw.item} ` : ""}${rw.qty_reject} ${satuan})` : ""}{bukanPenyebab ? " · bukan penyebab, hanya mengerjakan ulang" : ""}
      </span>
    );
  }
  return (
    <div data-testid={testid} className="rounded-lg border border-red-500/50 bg-red-500/10 px-3 py-2 text-sm text-red-100 space-y-0.5">
      <div className="font-semibold text-red-300">{judul} — {asalRework(rw)}{rw.qc_by_username ? ` oleh ${rw.qc_by_username}` : ""} {waktu(rw.qc_at)}</div>
      <div>Alasan / yang harus diperbaiki: <b>{rw.alasan}</b></div>
      {rw.pcs_bermasalah ? <div>Pcs/pemain bermasalah: <b>{rw.pcs_bermasalah}</b>{rw.qty_reject ? ` · ${rw.qty_reject} pcs` : ""}</div>
        : rw.qty_reject ? <div>Jumlah bermasalah: <b>{rw.item && rw.sumber === "POS" ? `${rw.item} · ` : ""}{rw.qty_reject} {satuan}</b></div> : null}
      {rw.pos_penyebab && <div className="text-xs text-red-200/80">Pos penyebab: {namaPos(rw.pos_penyebab, peta)}</div>}
      {bukanPenyebab && <div data-testid="rework-bukan-penyebab" className="text-xs text-slate-200">Pos ini bukan penyebab — hanya mengerjakan ulang pcs perbaikan (tidak dicatat sebagai kesalahan).</div>}
    </div>
  );
}
